/**
 * useElapsedSeconds (P142) -- whole seconds elapsed since `active` last
 * turned true. Ticks once per second while active; resets to 0 on the
 * inactive -> active edge; returns 0 while inactive. The "hasn't timed
 * out" signal behind EngineBusy -- works regardless of reduced-motion.
 */
import { useEffect, useRef, useState } from "react";

export function useElapsedSeconds(active: boolean): number {
  const [seconds, setSeconds] = useState(0);
  const startRef = useRef<number | null>(null);

  useEffect(() => {
    if (!active) {
      startRef.current = null;
      setSeconds(0);
      return;
    }
    startRef.current = Date.now();
    setSeconds(0);
    const id = setInterval(() => {
      if (startRef.current !== null) {
        setSeconds(Math.floor((Date.now() - startRef.current) / 1000));
      }
    }, 1000);
    return () => clearInterval(id);
  }, [active]);

  return seconds;
}
